import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';

import useDeceasedSummaryCard, { DeceasedSummaryCardProps } from './deceased-summary-card.controller';

const SummaryRow = ({ label, value }: { label: React.ReactNode; value: React.ReactNode }) => (
    <div className='flex h-6 w-full items-center justify-between gap-3'>
        <div className='text-brand-muted shrink-0'>{label}</div>
        <div className='text-foreground-default truncate text-right'>{value}</div>
    </div>
);

export const DeceasedSummaryCard = (props: DeceasedSummaryCardProps) => {
    const viewProps = useDeceasedSummaryCard(props);

    if (!viewProps.show) {
        return null;
    }

    return (
        <div
            data-testid='deceased-summary-card'
            className='flex w-full flex-col gap-3'>
            <p>{CommonMessage.OBJECTS.DECEASED.DEFAULT}</p>
            <div className='bg-background-surface flex w-full flex-col gap-2 rounded-2xl p-4'>
                {viewProps.isLoading ? (
                    <div className='flex w-full items-center justify-center py-2'>
                        <Spinner />
                    </div>
                ) : (
                    <>
                        {viewProps.name && (
                            <SummaryRow
                                label={CommonMessage.FORMS.NAME}
                                value={viewProps.name}
                            />
                        )}
                        {viewProps.statusLabel && (
                            <SummaryRow
                                label={CommonMessage.OBJECTS.COMMON_FIELDS.STATUS}
                                value={viewProps.statusLabel}
                            />
                        )}
                        {viewProps.dateOfDeathLabel && (
                            <SummaryRow
                                label={CommonMessage.OBJECTS.DECEASED.DATE_OF_DEATH}
                                value={viewProps.dateOfDeathLabel}
                            />
                        )}
                        {viewProps.elysLabel && (
                            <SummaryRow
                                label={CommonMessage.OBJECTS.DECEASED.ELYS_NUMBER}
                                value={viewProps.elysLabel}
                            />
                        )}
                        {viewProps.cremationLabel && (
                            <SummaryRow
                                label={CommonMessage.OBJECTS.DECEASED.CREMATION}
                                value={viewProps.cremationLabel}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default DeceasedSummaryCard;
